import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoCerdo = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Cerdo - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Cerdo. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Cerdo." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="cerdo" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Cerdo</h1>
              <p className="text-muted-foreground">Años: 1935, 1947, 1959, 1971, 1983, 1995, 2007, 2019, 2031</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu generosidad y calidez natural están especialmente brillantes hoy, Cerdo. Tu sinceridad y buen corazón atraen amor genuino. Las parejas disfrutarán de momentos de paz y felicidad compartida.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu diligencia y actitud positiva inspirarán a tu equipo hoy. Tu capacidad de trabajar arduamente sin perder el optimismo es admirable. Los esfuerzos honestos traerán recompensas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu naturaleza pacífica favorece el bienestar. Disfruta de placeres simples como buena comida y descanso adecuado. El equilibrio entre disfrutar la vida y mantener hábitos saludables es clave.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será ideal para disfrutar de la compañía de tu pareja en ambientes relajados. Tu naturaleza cariñosa creará momentos memorables. Los solteros podrían conocer a alguien en reuniones sociales.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu perseverancia paciente dará resultados mañana. Proyectos que requieren dedicación constante avanzarán significativamente. Tu ética de trabajo honesta será reconocida.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu bienestar estará en buen estado. Mantén la moderación en todo. Actividades placenteras como cocinar saludable o paseos tranquilos nutrirán tu cuerpo y espíritu.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de armonía y felicidad en las relaciones. Tu bondad natural creará un ambiente de amor y confianza. Las parejas disfrutarán de la simplicidad de estar juntos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu trabajo constante y honesto traerá prosperidad. Tu capacidad de mantener una actitud positiva incluso en desafíos inspirará a otros. El éxito llegará a través de la perseverancia.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Prioriza el equilibrio y la moderación esta semana. Tu naturaleza indulgente necesita disciplina gentil. Disfruta de la vida sin excesos, y tu bienestar se mantendrá óptimo.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoCerdo;
